/**
 * Budget bands used in Step 5 of the quote builder.
 * Hardcoded for Phase 2 — these can move to backend config later.
 * Amounts are in INR.
 */
export const BUDGET_BANDS = [
  {
    id: "modest",
    label: "Modest",
    sub: "Intimate, lean coverage",
    min: 25000,
    max: 60000,
  },
  {
    id: "standard",
    label: "Standard",
    sub: "Balanced day coverage",
    min: 60000,
    max: 150000,
  },
  {
    id: "premium",
    label: "Premium",
    sub: "Larger crew + cinema",
    min: 150000,
    max: 400000,
  },
  {
    id: "luxury",
    label: "Luxury",
    sub: "Multi-day, multi-camera",
    min: 400000,
    max: 1000000,
  },
  {
    id: "bespoke",
    label: "Bespoke",
    sub: "No upper limit",
    min: 1000000,
    max: null,
  },
];

export function findBandById(id) {
  return BUDGET_BANDS.find((b) => b.id === id) || null;
}
